<template>
	<div class="index">
		<div class="custom-tabbar-page">
			<div class="message">
				<div class="top-section">
					<!-- logo -->
					<div class="logo-container">
						<div class="logo">
							<img class="site-logo" src="/img/home/logo.png" alt="logo" />
						</div>
					</div>
					<!-- 轮播图 -->
					<van-swipe class="swiper_s" :autoplay="3000">
						<van-swipe-item v-for="(v,key) in banners" :key="key">
							<van-image :src="getAssetUrl(v.url)" width="100%">
								<template v-slot:loading>
									<van-loading type="circular" />
								</template>
							</van-image>
						</van-swipe-item>
					</van-swipe>
					<!-- 通知栏 -->
					<div class="wallpaper-shadow notice-bar">
						<div class="noticect">
							<van-notice-bar color="#000" background="#fff" left-icon="volume-o" scrollable
								:text="this.notice" />
						</div>
					</div>
				</div>
				<!-- 快捷功能入口 -->
				<div class="quick-access">
					<div class="quick-grid">
						<div class="quick-item" @click="$router.push({path:'/Task'});">
							<div class="icon-container">
								<div class="icon-wrapper">
									<img src="/img/home/icon_time.png" alt="" />
								</div>
							</div>
							<div class="quick-label">
								Begrenztes Ticket
							</div>
						</div>
						<div class="quick-item" @click="$router.push({path:'/Activity'});">
							<div class="icon-container">
								<div class="icon-wrapper">
									<img src="/img/home/icon_activity.png" alt="" />
								</div>
							</div>
							<div class="quick-label">
								Aktivitätszone
							</div>
						</div>
						<div class="quick-item" @click="$router.push({path:'/TaskList'});">
							<div class="icon-container">
								<div class="icon-wrapper">
									<img src="/img/home/icon_record.png" alt="" />
								</div>
							</div>
							<div class="quick-label">
								Bestellung aufzeichnen
							</div>
						</div>
						<div class="quick-item" @click="openServiceLink()">
							<div class="icon-container">
								<div class="icon-wrapper">
									<img src="/img/home/icon_service.png" alt="" />
								</div>
							</div>
							<div class="quick-label">
								Service kontaktieren
							</div>
						</div>
					</div>
				</div>

				<div class="movie-recommend">
					<div class="movie-header">
						<div class="movie-title">
							🎬 Beliebte Filme
						</div>
					</div>
					<div class="movie-grid">
						<div class="movie-item" v-for="item in visibleProductList" :key="item.id" @click="toTask(item.id)">
							<div class="movie-poster">
								<img :src="getAssetUrl(item.img)" :alt="item.name || 'product'" />
							</div>
							<div class="movie-name">
								{{ item.name }}
							</div>
						</div>
					</div>
					<div class="load-more-row" v-if="showLoadMore" @click="loadMoreProducts">
						<div class="load-more-text">
							Mehr anzeigen ›
						</div>
					</div>
				</div>

				<div class="partner-section">
					<div class="partner-header">
						<div class="partner-title">
							🤝 Partner
						</div>
					</div>
					<div class="partner-logos">
						<div class="partner-logo">
							<img src="/img/home/partners_1.jpg" alt="" />
						</div>
						<div class="partner-logo">
							<img src="/img/home/partners_2.jpg" alt="" />
						</div>
						<div class="partner-logo">
							<img src="/img/home/partners_3.jpg" alt="" />
						</div>
						<div class="partner-logo">
							<img src="/img/home/partners_4.jpg" alt="" />
						</div>
					</div>
				</div>

				<div class="tn-tabbar-height"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				notice: this.$t("index.loading"),
				translateY: -18,
				containerHeight: 0,
				hasToken: false,
				basicData: [],
				productList: [],
				visibleCount: 8,
				datalist: [],
				groupedData: [],
				banners: [{}],
				bannerSwiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					speed: 800,
					autoplay: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 10,
						depth: 100,
						modifier: 1,
						slideShadows: true
					}
				},
				tagTypes: ['primary', 'success', 'danger', 'warning']
			};
		},
		computed: {
			visibleProductList() {
				return this.productList.slice(0, this.visibleCount);
			},
			showLoadMore() {
				return this.visibleCount < this.productList.length;
			}
		},
		methods: {
			getCurrentLang() {
				return localStorage.getItem('lang') || this.$i18n.locale || 'de';
			},
			getAssetUrl(url) {
				if (!url) {
					return '';
				}

				if (/^https?:\/\//i.test(url)) {
					return url;
				}

				return `https://shuadan-2.0.qpl-005.site${url}`;
			},
			getBasicConfig() {
				this.$http({
					method: "get",
					url: "sys_config",
					data: {
						lang: this.getCurrentLang()
					}
				}).then((res) => {
					console.log('sys_config response:', res.data);
					this.basicData = res.data;
					console.log(this.basicData, "309");
					this.getNotice(this.basicData); //获取公告
					this.getBanner(this.basicData); //获取banner
					// this.getGameItem();//获取首页游戏列表
					// this.getMovieList_0(this.basicData);//获取首页视频0
					// this.getMovieList_1(this.basicData);//获取首页视频1
				});
			},
			getHotLottery() {
				this.$http({
					method: "get",
					url: "lottery_hot",
				}).then((res) => {
					console.log(res, 11)
				});
			},
			getBanner(data) {
				console.log('banners data:', data.banners);
				this.banners = data.banners;
			},
			getProductList() {
				this.$http({
					method: "get",
					url: "productList"
				}).then((res) => {
					this.productList = Array.isArray(res.data) ? res.data : [];
					this.visibleCount = 8;
				});
			},
			loadMoreProducts() {
				this.visibleCount = Math.min(this.visibleCount + 8, this.productList.length);
			},
			toLogin(str) {
				this.$router.push({
					path: str
				});
			},
			getNotice(data) {
				this.notice = data.notice;
			},
			startAnimation() {
				const interval = setInterval(() => {
					this.translateY -= 18;

					if (this.translateY <= -this.containerHeight) {
						this.translateY = 0;
					}
				}, 1000);

				// 可选：在组件销毁时清除定时器
				this.$once("hook:beforeDestroy", () => {
					clearInterval(interval);
				});
			},
			toDetail(id) {
				this.$router.push({
					path: "/detail",
					query: {
						id: id
					}
				});
			},
			toTask(productId) {
				if (!productId) {
					return;
				}

				this.$router.push({
					path: "/Task",
					query: {
						productId: productId
					}
				});
			},
			openServiceLink() {
				const service = this.$store.getters.getBaseInfo || {};
				if (service.iskefu == 1 && service.kefu) {
					window.location.href = service.kefu;
					return;
				}
				this.$toast(this.$t("setting.forbid"));
			},
			checkToken() {
				const token = localStorage.getItem("token");
				console.log(token);
				this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
				console.log(this.hasToken);
				this.$nextTick(() => {
					console.log("View updated:", this.hasToken);
				});
			},
			getxuanfeilist() {
				this.$http({
					method: "get",
					url: "xuanfeilist",
					data: {
						id: 1,
						page: 1
					},
				}).then((res) => {
					const lanng = localStorage.getItem("lang");
					console.log(lanng)
					this.datalist = res.data;
					this.datalist.forEach(item => {
						const parts = item.flag.split('|')
						lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] :
							lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3]
						item.flagArray = item.flag.split('，');

					})
					const chunkSize = 2;
					this.groupedData = this.datalist.reduce((acc, item, index) => {
						if (index % chunkSize === 0) acc.push([]);
						acc[Math.floor(index / chunkSize)].push(item);
						return acc;
					}, []);
					console.log(this.groupedData);
					console.log(res.data);
				});
			},
		},

		mounted() {
			if (this.$refs.scrollContainer) {
				this.containerHeight = this.$refs.scrollContainer.clientHeight;
				this.startAnimation();
			}
		},
		created() {
			this.checkToken();
			this.getBasicConfig();
			this.getProductList();
			this.getxuanfeilist();
			this.getHotLottery()
		},
		activated() {
			this.getBasicConfig();
		},
	};
</script>

<style lang="less" scoped>
	.index {
		width: 100%;
		height: 100vh;
		position: relative;
		background-color: #f2f2f2;
	}

	.index .custom-tabbar-page {
		width: 100%;
		height: calc(100vh - 62px);
		box-sizing: border-box;
		padding-bottom: 0px;
		padding-bottom: calc(0px + constant(safe-area-inset-bottom));
		padding-bottom: calc(0px + env(safe-area-inset-bottom));
	}

	.message {
		background-color: #f5f5f5;
		z-index: 1;
		min-height: 100vh;
		padding-bottom: 10px;
	}

	.top-section {
		padding: 7px;
	}

	.top-section .logo-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 2px;
		padding: 2px;
	}
	
	.top-section .logo-container .logo {
		height: 41px;
	}

	.top-section .logo-container .site-logo {
		width: 104px;
	}

	.top-section .swiper_s {
		height: 114px;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
		transition: -webkit-transform .3s ease;
		transition: transform .3s ease;
		transition: transform .3s ease, -webkit-transform .3s ease;
	}

	.top-section .swiper_s {
		height: 114px;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
		transition: -webkit-transform .3s ease;
		transition: transform .3s ease;
		transition: transform .3s ease, -webkit-transform .3s ease
	}

	.top-section .swiper_s:hover {
		-webkit-transform: translateY(-2px);
		transform: translateY(-2px)
	}

	.wallpaper-shadow {
		background-color: #fff;
	}

	.top-section .notice-bar {
		margin-top: 8px;
		border-radius: 6px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .05);
		padding: 6px 8px;
	}

	.quick-access {
		position: relative;
		z-index: 9999;
		padding: 0 10px;
		margin-top: 10px;
	}

	.quick-access .quick-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 10px;
	}

	.quick-access .quick-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: #fff;
		border-radius: 10px;
		padding: 12px 4px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
		transition: all .4s cubic-bezier(.175, .885, .32, 1.275);
		-webkit-animation: slideUp-data-v-7f1f068c .6s ease-out forwards;
		animation: slideUp-data-v-7f1f068c .6s ease-out forwards;
		opacity: 0;
		-webkit-transform: translateY(15px);
		transform: translateY(15px);
		min-width: 0;
		overflow: hidden
	}

	.quick-access .quick-item:hover {
		-webkit-transform: translateY(-4px) scale(1.05);
		transform: translateY(-4px) scale(1.05);
		box-shadow: 0 3px 12px rgba(0, 0, 0, .12)
	}

	.quick-access .quick-item:active {
		-webkit-transform: translateY(-2px) scale(.95);
		transform: translateY(-2px) scale(.95)
	}

	.quick-access .icon-container {
		margin-bottom: 8px;
	}

	.quick-access .icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 45px;
		height: 45px;
		border-radius: 10px;
		background: #f8f9fa;
		box-shadow: 0 1px 4px rgba(0, 0, 0, .08);
	}

	.quick-access .icon-wrapper img {
		width: 30px;
		height: 30px;
	}

	.quick-access .quick-label {
		font-size: 11px;
		font-weight: 500;
		color: #333;
		text-align: center;
		margin-top: 4px;
		word-break: break-word;
		white-space: normal;
		width: 100%;
		padding: 0 2px;
		box-sizing: border-box;
	}

	.movie-recommend {
		background: #fff;
		margin: 12px 10px;
		padding: 12px;
		border-radius: 10px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
	}

	.movie-recommend .movie-header {
		margin-bottom: 12px;
		padding-bottom: 8px;
		border-bottom: 0.5px solid #f0f0f0;
	}

	.movie-recommend .movie-header .movie-title {
		font-size: 17px;
		font-weight: 700;
		color: #333;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.movie-recommend .movie-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}

	.movie-recommend .movie-grid .movie-item {
		min-width: 0;
		overflow: hidden;
		cursor: pointer;
		transition: all .4s cubic-bezier(.175, .885, .32, 1.275);
		-webkit-animation: slideUp-data-v-7f1f068c .6s ease-out forwards;
		animation: slideUp-data-v-7f1f068c .6s ease-out forwards;
		opacity: 0;
		-webkit-transform: translateY(15px);
		transform: translateY(15px);
	}

	.movie-recommend .movie-grid .movie-item:hover {
		-webkit-transform: translateY(-4px) scale(1.02);
		transform: translateY(-4px) scale(1.02)
	}

	.movie-recommend .movie-grid .movie-item .movie-poster {
		width: 100%;
		height: 176px;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .15);
		position: relative;
	}

	.movie-recommend .movie-grid .movie-item .movie-poster img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: -webkit-transform .5s ease;
		transition: transform .5s ease;
		transition: transform .5s ease, -webkit-transform .5s ease;
	}

	.movie-recommend .movie-grid .movie-item .movie-poster img:hover {
		-webkit-transform: scale(1.1);
		transform: scale(1.1)
	}

	.movie-recommend .movie-grid .movie-item .movie-name {
		width: 100%;
		min-width: 0;
		margin-top: 8px;
		font-size: 14px;
		color: #333;
		text-align: center;
		font-weight: 500;
		line-height: 1.35;
		word-break: break-word;
		overflow-wrap: anywhere;
	}

	.load-more-row {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 0 4px;
		cursor: pointer;
	}

	.load-more-text {
		font-size: 13px;
		color: #667eea;
		font-weight: 600;
		letter-spacing: 0.5px;
	}

	.partner-section {
		background: #fff;
		margin: 12px 8px;
		padding: 12px;
		border-radius: 10px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
	}

	.partner-section .partner-header {
		margin-bottom: 12px;
		padding-bottom: 8px;
		border-bottom: 0.5px solid #f0f0f0;
	}

	.partner-section .partner-header .partner-title {
		font-size: 16px;
		font-weight: 700;
		color: #333;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.partner-section .partner-logos {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		gap: 8px;
	}

	.partner-section .partner-logos .partner-logo {
		flex: 0 0 calc(25% - 6px);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px;
		background: linear-gradient(135deg, #667eea, #764ba2);
		border-radius: 6px;
		transition: all .3s ease;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .1);
	}

	.partner-section .partner-logos .partner-logo:hover {
		-webkit-transform: translateY(-2px);
		transform: translateY(-2px);
		box-shadow: 0 2px 10px rgba(102, 126, 234, .2)
	}

	.partner-section .partner-logos .partner-logo img {
		width: 100%;
		height: 41px;
		object-fit: contain;
	}

	.tn-tabbar-height {
		min-height: 31px;
		height: calc(31px + env(safe-area-inset-bottom) / 2);
		height: calc(31px + constant(safe-area-inset-bottom));
	}

	/* 动画效果 */
	@-webkit-keyframes slideUp-data-v-7f1f068c {
		from {
			opacity: 0;
			-webkit-transform: translateY(15px);
			transform: translateY(15px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	@keyframes slideUp-data-v-7f1f068c {
		from {
			opacity: 0;
			-webkit-transform: translateY(15px);
			transform: translateY(15px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	@-webkit-keyframes pulse-data-v-7f1f068c {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1);
			opacity: 1
		}

		50% {
			-webkit-transform: scale(1.2);
			transform: scale(1.2);
			opacity: .8
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1);
			opacity: 1
		}
	}

	@keyframes pulse-data-v-7f1f068c {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1);
			opacity: 1
		}

		50% {
			-webkit-transform: scale(1.2);
			transform: scale(1.2);
			opacity: .8
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1);
			opacity: 1
		}
	}

	/* 响应式调整 */
	@media (max-width:195px) {
		.quick-access {
			padding: 0 8px
		}

		.quick-access .quick-grid {
			gap: 8px
		}

		.movie-recommend {
			margin: 10px 8px;
			padding: 10px
		}

		.movie-grid {
			gap: 10px
		}

		.movie-grid .movie-poster {
			height: 156px
		}

		.partner-section {
			margin: 10px 8px;
			padding: 10px
		}

		.partner-section .partner-logos {
			gap: 6px
		}

		.partner-section .partner-logos .partner-logo {
			flex: 0 0 calc(25% - 4px);
			padding: 8px
		}

		.partner-section .partner-logos .partner-logo img {
			height: 31px
		}
	}

	/* 更小屏幕调整 */
	@media (max-width:166px) {
		.partner-logos .partner-logo {
			flex: 0 0 calc(50% - 4px)
		}

		.partner-logos .partner-logo img {
			height: 36px
		}
	}

	/* 页面阴影 */
	.wallpaper-shadow {
		background-color: #fff
	}
</style>
